import React, { useState } from 'react';
import GeoclientWrapper from './GeoclientWrapper';

const GeoclientBar = (props) => {
  const { user, isAuth } = props;
  const [isOpen, setOpen] = useState(false);

  let avatar = 'https://crm.geograftour.com/img/avatars/tourist-avatar.png';

  if (user && user.info) {
    if (!!user.info.avatar) {
      avatar = `https://crm.geograftour.com${user.info.avatar}`;
    }
  }

  let { tours } = props.tours || [];

  if (!localStorage.getItem('tourStack')) {
    localStorage.setItem('tourStack', JSON.stringify([]));
  } else {
    tours = JSON.parse(localStorage.getItem('tourStack'));
  }

  return (
    <div id="geoclient" className="geoclient__wrapper">
      <div className="geoclient body-wrapper">
        {isAuth ? (
          <div className="geoclient__user-info">
            <img className="geoclient__user-img" src={avatar} alt="" />
            <p className="geoclient__username">
              {user.last_name + ' ' + user.first_name}
            </p>
          </div>
        ) : (
          <h3 className="geoclient__header">ГЕОПОДБОРКА</h3>
        )}

        <div
          onClick={() => setOpen(!isOpen)}
          id="geoclient__icon__popup"
          className="geoclient__open-popup-btn"
        >
          <span id="tours-count" className="geoclient__tour-counter">
            {tours?.length || 0}
            <img
              width="25"
              src="https://geograftour.com/static/index/img/geoclient/icon2.png"
              alt=""
            />
          </span>
        </div>
      </div>
      <GeoclientWrapper
        onClose={() => setOpen(false)}
        {...props}
        tours={tours}
        is_open={isOpen}
      />
    </div>
  );
};

export default GeoclientBar;
